import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const ContentMarketing = () => {
	return (
		<div className="min-h-screen flex flex-col">
			<Header />
			<main className="flex-grow">
				{/* Hero Section */}
				<div className="relative bg-gray-900">
          <div className="absolute inset-0">
            <img
              className="w-full h-full object-cover opacity-30"
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
              alt="Content marketing"
            />
          </div>
          <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
						<div className="text-center">
							<h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
								Content That Connects & Converts
							</h1>
							<p className="mt-6 max-w-3xl text-xl text-gray-100 mx-auto">
								We craft compelling, SEO-optimized content that attracts your ideal customers, builds trust, and drives measurable business growth.
							</p>
							<div className="mt-10">
								<Link
									to="/contact"
									className="inline-block bg-indigo-600 py-3 px-8 border border-transparent rounded-md text-base font-medium text-white hover:bg-indigo-700"
								>
									Get Your Content Strategy
								</Link>
							</div>
						</div>
					</div>
        </div>

				{/* Benefits Section */}
				<div className="bg-gray-50 py-16">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="lg:text-center">
							<h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
								Why Content Marketing?
							</h2>
							<p className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
								The Power of Strategic Storytelling
							</p>
						</div>

						<div className="mt-16">
							<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
								{[
									{
									title: "3X More Leads",
									desc: "Content marketing generates 3x more leads than paid search advertising.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
										</svg>
									)
									},
									{
									title: "Cost Effective",
									desc: "Costs 62% less than traditional marketing while generating 3x as many leads.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
										</svg>
									)
									},
									{
									title: "Builds Trust",
									desc: "84% of consumers expect brands to produce content that entertains, provides solutions, and creates experiences.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
										</svg>
									)
									},
									{
									title: "SEO Benefits",
									desc: "High-quality content is the #1 factor for ranking higher in search engines.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
										</svg>
									)
									},
									{
									title: "Long-Term Results",
									desc: "Unlike ads, great content continues working for you months and years after publication.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
										</svg>
									)
									},
									{
									title: "Competitive Edge",
									desc: "Only 42% of marketers document their content strategy - stand out with a plan.",
									icon: (
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
										</svg>
									)
									},
								].map((feature) => (
									<div key={feature.title} className="pt-6">
										<div className="flow-root bg-white rounded-lg px-6 pb-8 h-full shadow">
											<div className="-mt-6">
												<div>
													<span className="inline-flex items-center justify-center p-3 bg-indigo-500 rounded-md shadow-lg">
														{feature.icon}
													</span>
												</div>
												<h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">
													{feature.title}
												</h3>
												<p className="mt-5 text-base text-gray-500">
													{feature.desc}
												</p>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>

				{/* Services Section */}
				<div className="py-16 bg-white">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<h2 className="text-3xl font-extrabold text-gray-900 text-center">
							Our Content Marketing Services
						</h2>
						<p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto text-center">
							Comprehensive solutions tailored to your business goals
						</p>

						<div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
							{[
								{
									name: "Content Strategy",
									description:
										"Data-driven roadmap for content that aligns with your business objectives and audience needs.",
									features: [
										"Audience research",
										"Content audit",
										"Editorial calendar",
										"Performance metrics",
									],
								},
								{
									name: "Blog Content",
									description:
										"Regular, high-quality blog posts that establish thought leadership and drive organic traffic.",
									features: [
										"SEO-optimized articles",
										"Industry research",
										"Engaging storytelling",
										"Monthly content plans",
									],
								},
								{
									name: "Ebooks & Guides",
									description:
										"In-depth resources that generate leads and demonstrate expertise.",
									features: [
										"Professional design",
										"Lead generation focused",
										"Comprehensive research",
										"Multi-format distribution",
									],
								},
								{
									name: "Social Media Content",
									description:
										"Platform-specific content that increases engagement and brand awareness.",
									features: [
										"Platform strategy",
										"Visual content creation",
										"Community engagement",
										"Performance analytics",
									],
								},
								{
									name: "Email Marketing",
									description:
										"Targeted content that nurtures leads and retains customers.",
									features: [
										"Newsletter creation",
										"Drip campaigns",
										"Personalization",
										"Conversion optimization",
									],
								},
								{
									name: "Video Content",
									description:
										"Engaging video scripts and concepts that tell your brand story.",
									features: [
										"Script writing",
										"Storyboarding",
										"SEO optimization",
										"Distribution strategy",
									],
								},
							].map((service) => (
								<div
									key={service.name}
									className="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200"
								>
									<div className="p-6">
										<h3 className="text-lg font-medium text-gray-900">
											{service.name}
										</h3>
										<p className="mt-2 text-sm text-gray-500">
											{service.description}
										</p>
									</div>
									<div className="px-6 pt-6 pb-8">
										<ul className="space-y-4">
											{service.features.map((feature) => (
												<li key={feature} className="flex items-start">
													<div className="flex-shrink-0">
														<svg
															className="h-6 w-6 text-green-500"
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															stroke="currentColor"
														>
															<path
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth={2}
																d="M5 13l4 4L19 7"
															/>
														</svg>
													</div>
													<p className="ml-3 text-sm text-gray-700">{feature}</p>
												</li>
											))}
										</ul>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* CTA Section */}
				<div id="contact" className="bg-indigo-700">
					<div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
						<h2 className="text-3xl font-extrabold text-white sm:text-4xl">
							Ready to transform your content marketing?
						</h2>
						<p className="mt-4 text-lg leading-6 text-indigo-200">
							Get in touch to discuss how we can help you attract, engage, and convert more customers through strategic content.
						</p>
						<Link
							to="/contact"
							className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-indigo-50 sm:w-auto"
						>
							Contact Our Team
						</Link>
					</div>
				</div>
			</main>
			<Footer />
		</div>
	)
}

export default ContentMarketing
